module.exports = "https://static.wmbcdn.com/uniweb/images/3e9eb25c851a006038a90fff2739e07c.svg";